<template lang="pug">
.content-center.all-market
  //- small.text-dark {{ selectedMatchMore && selectedMatchMore.hasOwnProperty('details') && selectedMatchMore['details'] }}
  .overlay(@click="hide()")
  .back-btn(@click="back()")
    i.fa-solid.fa-left-long
    |  {{ $t("ui.back") }} 
  template(v-if="selectedMatchMore")
    .upcoming-group
      .dropdown(v-if="marketKeys.length > 0")
        button#dd-more-match.btn-dropdown(type='button' data-bs-toggle='dropdown' aria-expanded='false')
          i.fa-solid.fa-caret-down
        ul.dropdown-menu(aria-labelledby='dd-more-match')
          template(v-for="(ml, mk) in liveMarketKeys")
            template(v-for="(ll, lk) in marketList[ml].leagueList")
              li
                a.dropdown-item(href="javascript:void(0);" @click="setLeague(ll)")
                  ThemeImage.icon(:src='"/images/light/sport/blue/" + getSportsImage(ll.sportsId)+ ".svg"' alt='')
                  span {{ ll.leagueName }}
          template(v-for="(ml, mk) in todayMarketKeys")
            template(v-for="(ll, lk) in marketList[ml].leagueList")
              li
                a.dropdown-item(href="javascript:void(0);" @click="setLeague(ll)")
                  ThemeImage.icon(:src='"/images/light/sport/blue/" + getSportsImage(ll.sportsId)+ ".svg"' alt='')
                  span {{ ll.leagueName }}
          template(v-for="(ml, mk) in earlyMarketKeys")
            template(v-for="(ll, lk) in marketList[ml].leagueList")
              li
                a.dropdown-item(href="javascript:void(0);" @click="setLeague(ll)")
                  ThemeImage.icon(:src='"/images/light/sport/blue/" + getSportsImage(ll.sportsId)+ ".svg"' alt='')
                  span {{ ll.leagueName }}
      .scrolling-wrapper(v-if="selectedMatchMore && selectedMatchMore.categoryId")
        template(v-for="(ml, mk) in liveMarketKeys")
          template(v-if="selectedMatchMore && selectedMatchMore.categoryId && ml == selectedMatchMore.categoryId && marketList[selectedMatchMore.categoryId]")
            template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
              template(v-if="selectedMatchMore && ll.id == selectedMatchMore.groupId")
                template(v-for="(mml, mmk) in ll.matchList")
                  moreTop(:source="mml" :index="mmk")
        template(v-for="(ml, mk) in todayMarketKeys")
          template(v-if="selectedMatchMore && selectedMatchMore.categoryId && ml == selectedMatchMore.categoryId && marketList[selectedMatchMore.categoryId]")
            template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
              template(v-if="selectedMatchMore && ll.id == selectedMatchMore.groupId")
                template(v-for="(mml, mmk) in ll.matchList")
                  moreTop(:source="mml" :index="mmk")
        template(v-for="(ml, mk) in earlyMarketKeys")
          template(v-if="selectedMatchMore && selectedMatchMore.categoryId && ml == selectedMatchMore.categoryId && marketList[selectedMatchMore.categoryId]")
            template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
              template(v-if="selectedMatchMore && ll.id == selectedMatchMore.groupId")
                template(v-for="(mml, mmk) in ll.matchList")
                  moreTop(:source="mml" :index="mmk")
  
    //- .all-m-match-info
    //-   .m-card-header
    //-     .group
    //-       .icon.inactive
    //-         img(:src='"/images/light/sport/blue/" + getSportsImage(selectedMatchMore.sportsId) + ".svg"' alt='')
    //-       .icon.active
    //-         img(:src='"/images/light/sport/white/" + getSportsImage(selectedMatchMore.sportsId) + ".svg"' alt='')
    //-       .league-name {{ selectedMatchMore.leagueName }}
    //-   .m-card-match
    //-     TimePanel(:source="selectedMatchMore" isHideScore=true)
    //-     .team-wrap
    //-       .team.team-red
    //-         .team-logo
    //-           img(src='images/team-logo/home-team.png')
    //-         .team-name {{ selectedMatchMore.homeTeam }}
    //-         .score {{ selectedMatchMore.runningScore ? selectedMatchMore.runningScore.split('-')[0] : '0' }}
    //-       .team
    //-         .team-logo
    //-           img(src='images/team-logo/away-team.png')
    //-         .team-name {{ selectedMatchMore.awayTeam }}
    //-         .score {{ selectedMatchMore.runningScore ? selectedMatchMore.runningScore.split('-')[1] : '0' }}
  
    template(v-if="selectedMatchMore != null && (selectedMatchMore.channelId || selectedMatchMore.radarId)")
      .tab-nav
        ul.scrolling-wrapper
          li(v-if="selectedMatchMore.channelId")
            a(href="javascript:void(0);" :class="{ 'active': mode == 0 }" @click="setMode(0)")
              i.fa-solid.fa-tv
              |  {{ $t("ui.live_tv") }} 
          //- li(v-if="selectedMatchMore.stats")
          //-   a(href="javascript:void(0);" :class="{ 'active': mode == 2 }" @click="setMode(2)")
          //-     i.fa-solid.fa-chart-bar
          //-     |  {{ $t("ui.statistics") }}
          //- li
          //-   a(href='#')
          //-     img(src='images/icon/others/match.svg' alt='')
          //-     |  Live Match
      #collapse-livetv.live-tv.collapse
        .live-tv-aspect
          .highlight-match-info
            i.fa.fa-spinner.fa-spin(v-if="loader")
            span(v-if="error") {{ error == 'Match Not Started' ? "" : error }}
          img(src='images/livematch.png')
          #live-widget-iframe
      .btn-collapse(data-bs-toggle='collapse' href='#collapse-livetv' role='button' aria-expanded='false' aria-controls='collapse-livetv')

      //- #live-widget-btn.screen-btn.show(@click="toggleWidget()")
    template(v-if="selectedMatchMore && selectedMatchMore.hasOwnProperty('details') && selectedMatchMore['details']")
      moreContent(
        v-if="selectedMatchMore"
        :source="selectedMatchMore"
        :child1Ids="selectedMatchMore.details.child1"
        :child2Ids="selectedMatchMore.details.child2"
        @popup-livetv="stopMainLiveTV"
      )

            
  .market-group(v-else-if="selectedMatch && !selectedMatchMore")
    loading


//- #content.snap-content
//-   //- small.text-light {{ this.selectedMatch }}
//-   //- small.text-light {{ selectedMatchMore }}
//-   //- small.text-light details
//-   //- small.text-light(v-if="selectedMatchMore && selectedMatchMore.hasOwnProperty('details') && selectedMatchMore['details']") {{ selectedMatchMore['details'] }}

//-   .overlay(@click="hide()")
//-   Marquee(:class="{ 'd-none': !whiteLabel }")
//-   toolBar
//-   .content-center.content-more(v-if="selectedMatchMore")
//-     .position-relative
//-       .morebet-wrapper
//-         .morebet-back
//-           a(href='javascript:void(0);' @click="back()")
//-             i.fas.fa-arrow-left
//-         .morebet-nav
//-           ul.nav.p-0.m-0
//-             template(v-if="marketKeys.length > 0")
//-               template(v-for="(ml, mk) in liveMarketKeys")
//-                 template(v-if="ml == selectedMatchMore.categoryId")
//-                   template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
//-                     template(v-if="ll.id == selectedMatchMore.groupId")
//-                       template(v-for="(mml, mmk) in ll.matchList")
//-                         moreTop(:source="mml" :index="mmk")
//-               template(v-for="(ml, mk) in todayMarketKeys")
//-                 template(v-if="ml == selectedMatchMore.categoryId")
//-                   template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
//-                     template(v-if="ll.id == selectedMatchMore.groupId")
//-                       template(v-for="(mml, mmk) in ll.matchList")
//-                         moreTop(:source="mml" :index="mmk")
//-               template(v-for="(ml, mk) in earlyMarketKeys")
//-                 template(v-if="ml == selectedMatchMore.categoryId")
//-                   template(v-for="(ll, lk) in marketList[selectedMatchMore.categoryId].leagueList")
//-                     template(v-if="ll.id == selectedMatchMore.groupId")
//-                       template(v-for="(mml, mmk) in ll.matchList")
//-                         moreTop(:source="mml" :index="mmk")
//-             template(v-if="marketKeys.length > 0")
//-               li.dropdown.select-league-dropdown
//-                 #dropdownMenuButton.btn-select-league.dropdown-toggle(@click="toggleDropdown()" aria-expanded="false")
//-       .tab-content
//-         .tab-pane.fade.show.active
//-           .more-market-content(:class="{ 'is-live' : selectedMatchMore ? selectedMatchMore.marketId == 3 : false }")
//-             template(v-if="selectedMatchMore != null && (selectedMatchMore.channelId || selectedMatchMore.radarId)")
//-               div
//-                 ul.m-0.p-0.match-detail-function-tab
//-                   li(v-if="selectedMatchMore.channelId")
//-                     a.nav-link(:class="{ 'active': mode == 0 }" @click="setMode(0)")
//-                       .icon-function
//-                         img(:src="(selectedMatchMore.marketId == 3) ? '/images/live-stream-live.svg?v=12' : '/images/live-stream.svg?v=12'")
//-               #live-widget.live-center
//-                 i(v-if="loader").fa.fa-spinner.fa-spin
//-                 span(v-else) {{ error }}
//-                 #live-widget-iframe
//-               #live-widget-btn.screen-btn.show(@click="toggleWidget()")
//-             template(v-if="selectedMatchMore && selectedMatchMore.hasOwnProperty('details') && selectedMatchMore['details']")
//-               moreContent(
//-                 v-if="selectedMatchMore"
//-                 :source="selectedMatchMore"
//-                 :child1Ids="selectedMatchMore.details.child1"
//-                 :child2Ids="selectedMatchMore.details.child2"
//-               )
//-     #dropdown-select-league.dropdown-menu.dropdown-select-league
//-       template(v-for="(ml, mk) in liveMarketKeys")
//-         template(v-for="(ll, lk) in marketList[ml].leagueList")
//-           a.dropdown-item.live(href="javascript:void(0);" @click="setLeague(ll)")
//-             span.icon
//-               img(:src="'/images/icon-sport-svg/' + getSportsImage(ll.sportsId)")
//-               img.live-icon(src='/images/live.svg?v=12')
//-             | {{ ll.leagueName }}
//-       template(v-for="(ml, mk) in todayMarketKeys")
//-         template(v-for="(ll, lk) in marketList[ml].leagueList")
//-           template(v-if="[41, 42, 43, 44, 47].includes(ll.sportsId)")
//-             a.dropdown-item.live(href="javascript:void(0);" @click="setLeague(ll)")
//-               span.icon
//-                 img(:src="'/images/icon-sport-svg/' + getSportsImage(ll.sportsId)")
//-                 img.live-icon(src='/images/live.svg?v=12')
//-               | {{ ll.leagueName }}
//-           template(v-else)
//-             a.dropdown-item(href="javascript:void(0);" @click="setLeague(ll)")
//-               span.icon
//-                 img(:src="'/images/icon-sport-svg/' + getSportsImage(ll.sportsId)")
//-               | {{ ll.leagueName }}
//-       template(v-for="(ml, mk) in earlyMarketKeys")
//-         template(v-for="(ll, lk) in marketList[ml].leagueList")
//-           a.dropdown-item(href="javascript:void(0);" @click="setLeague(ll)")
//-             span.icon
//-               img(:src="'/images/icon-sport-svg/' + getSportsImage(ll.sportsId)")
//-             | {{ ll.leagueName }}
//-       //- a.dropdown-item(@click="toggleDropdown()").text-center
//-       //-   i.fa.fa-chevron-up
//-   template(v-else)
//-     .preloader
//-       .loader
//-   footerNav
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-game.js";
import { EventBus } from "@/library/_event-bus.js";
import mixinMain from "@/library/mixinMain.js";
import mixinExt from "@/library/mixinExt.js";
import moreTop from "@/components/mobile/main/more/moreTop";
import loading from "@/components/ui/loading";
import moreContent from "@/components/mobile/main/more/moreContent";

export default {
  components: {
    moreTop,
    loading,
    moreContent
  },
  mixins: [mixinMain, mixinExt],
  data() {
    return {
      mode: 0,
      error: null,
      url: "",
      embedded: false,
      loader: false,
      verifyAttempts: 0
    };
  },
  computed: {
    whiteLabel() {
      // return this.$store.getters.whiteLabel;
      return config.whiteLabel == "1";
    },
    asidebar() {
      return this.$store.getters.minimizer.asidebar;
    },
    radarId() {
      return this.$store.state.layout.radarId;
    },
    channel() {
      return this.$store.state.layout.channel;
    },
    selectedMatchMore() {
      return this.matchList[this.selectedMatch];
    },
    newFeatures() {
      return config.newFeatures;
    }
  },
  destroyed() {
    EventBus.$off("MARKET_NODATA", this.back);
    EventBus.$off("MARKET_DONE", this.verifySelectedMatch);
    if (this._resizeWidgetHandler) {
      window.removeEventListener("resize", this._resizeWidgetHandler);
    }
    var collapseEl = document.getElementById("collapse-livetv");
    if (collapseEl && this._collapseShowHandler) {
      collapseEl.removeEventListener("show.bs.collapse", this._collapseShowHandler);
    }
  },
  mounted() {
    EventBus.$on("MARKET_NODATA", this.back);
    EventBus.$on("MARKET_DONE", this.verifySelectedMatch);
    EventBus.$on("INVALIDATE", this.runInvalidate);
    this._resizeWidgetHandler = () => {
      this.resizeWidget(this.mode);
    };
    window.addEventListener("resize", this._resizeWidgetHandler);
    this.$nextTick(() => {
      var collapseEl = document.getElementById("collapse-livetv");
      if (collapseEl) {
        this._collapseShowHandler = () => {
          this.resizeWidget(this.mode);
        };
        collapseEl.addEventListener("show.bs.collapse", this._collapseShowHandler);
      }
    });
    this.autoPlay(this.$route.params.mode);
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    runInvalidate() {
      this.autoPlay(this.$route.params.mode);
    },
    setLeague(e) {
      if (e != null && e.matchList != null && e.matchList.length > 0) {
        this.$store.dispatch("layout/setSelectedMatch", e.matchList[0].matchId);
        EventBus.$emit("INVALIDATE");
      } else {
        this.back();
      }
    },
    verifySelectedMatch() {
      // Prevent infinite loops - max 10 attempts (5 seconds total)
      if (this.verifyAttempts >= 5) {
        this.verifyAttempts = 0;
        return;
      }
      
      // Wait a bit if match2 is still loading or if selectedMatchMore is not ready yet
      if (this.loading && this.loading.match2 === true) {
        this.verifyAttempts++;
        setTimeout(() => {
          this.verifySelectedMatch();
        }, 500);
        return;
      }
      
      // Also check if selectedMatchMore exists (it's computed from matchList)
      // This means the match data from GET_MATCH2 hasn't been processed yet
      if (this.selectedMatchMore == null && this.selectedMatch != null) {
        this.verifyAttempts++;
        setTimeout(() => {
          this.verifySelectedMatch();
        }, 500);
        return;
      }
      
      // Reset attempts counter on successful check
      this.verifyAttempts = 0;
      
      var a = Object.keys(this.matchList);
      if (!a.includes(this.selectedMatch.toString())) {
        this.back();
      }
    },
    autoPlay(e) {
      if (this.selectedMatchMore == null) {
        setTimeout(() => {
          this.autoPlay(e);
        }, 1000);
      } else {
        if (this.selectedMatchMore.channelId) {
          if (this.selectedMatchMore.marketId == 3) {
            if (e != null) {
              this.mode = e;
            } else {
              this.mode = 0;
            }
          } else {
            this.mode = 0;
            // if (this.selectedMatchMore.radarId > 0) {
            //   this.mode = 1;
            // } else {
            //   this.mode = 0;
            // }

            // if (this.selectedMatchMore.stats > 0) {
            //   this.mode = 2;
            // } else if (this.selectedMatchMore.radarId > 0) {
            //   this.mode = 1;
            // } else {
            //   this.mode = 0;
            // }
          }
        } else {
          this.mode = 0;
        }

        this.openWidget();
      }
    },
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    collapseWidget() {
      var collapseEl = document.getElementById('collapse-livetv');
      if (collapseEl) {
        var bsCollapse = bootstrap.Collapse.getInstance(collapseEl);
        if (!bsCollapse) {
          bsCollapse = new bootstrap.Collapse(collapseEl, { toggle: false });
        }
        bsCollapse.hide();
      }
    },
    expandWidget() {
      var collapseEl = document.getElementById('collapse-livetv');
      if (collapseEl) {
        var bsCollapse = bootstrap.Collapse.getInstance(collapseEl);
        if (!bsCollapse) {
          bsCollapse = new bootstrap.Collapse(collapseEl, { toggle: false });
        }
        bsCollapse.show();
      }
    },
    back() {
      this.$store.dispatch("layout/resetSelectLeague");
      this.$store.dispatch("layout/setSelectedMatch", null);
      setTimeout(() => {
        this.$router.push("/prematch").catch(err => {});
      }, 500);
    },
    openWidget() {
      this.resizeWidget(this.mode);
      switch (this.mode) {
        case 0:
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.channelId != null && this.selectedMatchMore.channelId > 0 && this.selectedMatchMore.marketId == 3 && this.selectedMatchMore.sportsId != null) {
            this.openLiveMatch();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 1:
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.radarId != null) {
            this.openLiveTracker();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 2:
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.stats != null) {
            this.xLinkStats();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
      }
    },
    closeWidget(e) {
      this.setWidget("");
      this.error = this.$t("message.match_not_started");
      this.collapseWidget();
    },
    stopMainLiveTV() {
      this.loader = false;
      this.setWidget("");
      this.error = "";
      this.collapseWidget();
    },
    setWidget(e) {
      $("#live-widget-iframe").html(e);
    },
    setMode(e) {
      this.mode = e;
      this.setWidget("");
      this.error = this.$t("message.match_not_started");
      this.resizeWidget(e);
      switch (e) {
        case 0:
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.channelId != null && this.selectedMatchMore.channelId > 0 && this.selectedMatchMore.marketId == 3 && this.selectedMatchMore.sportsId != null) {
            this.openLiveMatch();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 1:
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.radarId != null) {
            this.openLiveTracker();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
        case 2:
          this.error = "";
          if (this.selectedMatchMore != null && this.selectedMatchMore.stats != null) {
            this.xLinkStats();
            this.expandWidget();
          } else {
            this.closeWidget();
          }
          break;
      }
    },
    openLiveMatch() {
      if (this.selectedMatchMore != null && this.selectedMatchMore.channelId != null && this.selectedMatchMore.channelId > 0 && this.selectedMatchMore.marketId == 3 && this.selectedMatchMore.sportsId != null) {
        if (this.selectedMatchMore.channelId == "1") {
          this.launchLiveTV(this.selectedMatchMore.channelId, this.selectedMatchMore.matchId, this.selectedMatchMore.sportsId, "1.1.1.1");
        } else {
          this.getVersion().then(
            res => {
              if (this.selectedMatchMore != null && this.selectedMatchMore.channelId != null) {
                let ip = res;
                this.launchLiveTV(this.selectedMatchMore.channelId, this.selectedMatchMore.matchId, this.selectedMatchMore.sportsId, ip);
              }
            },
            err => {
              this.error = err;
            }
          );
        }
      } else {
        this.closeWidget();
      }
    },
    xLinkStats(e) {
      if (this.selectedMatchMore && this.selectedMatchMore.stats) {
        var url = config.statscenterUrl() + this.selectedMatchMore.stats + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken + "&l=" + this.$store.getters.language;
        // window.open(url, "stats", "top=10,height=540,width=900,status=no,toolbar=no,menubar=no,location=no");
        var html = '<iframe src="' + url + '" frameborder="0" allowfullscreen="true" scrolling="no">';
        this.setWidget(html);
      }
      return false;
    },
    resizeWidget(e) {
      var aspectW = 414;
      var aspectH = e == 1 ? 322 : 234;
      var aspectEl = document.querySelector("#collapse-livetv .live-tv-aspect");
      if (aspectEl) {
        aspectEl.style.aspectRatio = aspectW + " / " + aspectH;
      }
      var collapseEl = document.getElementById("collapse-livetv");
      if (collapseEl) {
        collapseEl.style.height = "";
      }
    },
    tvLink(e) {
      if (config.vg1.includes(e)) {
        return config.player10Url();
      } else {
        return config.bintuUrl();
      }
    },
    launchLiveTV(ch, mc, sp, ip) {
      var args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        channel: ch,
        match: mc,
        sports: sp,
        ip: ip
      };
      this.loader = true;
      this.error = "";
      xhr.launchLiveTV(args).then(
        res => {
          this.loader = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              this.embedded = this.url.includes("<iframe");
              if (!this.embedded) {
                this.embedded = this.url.includes("<script");
              }

              if (!this.embedded) {
                // not a iframe link, can be glive or self-hosted live streaming
                //
                if (ch != 1) {
                  var link = this.url + "&compact=1";
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                } else {
                  // var link = config.bintuUrl() + this.url + "&u=" + args.account_id + "&t=" + args.session_token;
                  var link = this.tvLink(sp) + this.url + "&u=" + args.account_id + "&t=" + args.session_token + "&product=" + sp;
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                }
              } else {
                // is a iframe link, can be twitch, youtube or any embeded video
                var kns = this.url.replace("www.example.com", window.location.hostname);
                this.setWidget(kns);
              }
            } else {
              this.error = this.$t("error." + res.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loader = false;
          this.error = this.$t("error." + err.status);
        }
      );
    },
    getVersion(q) {
      const url = "https://api.ipify88.com/";
      const feedback = {
        success: false,
        status: errors.login.failed
      };
      return new Promise((resolve, reject) => {
        this.$http.get(url).then(
          res => {
            resolve(res.bodyText);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    openLiveTracker() {
      if (this.selectedMatchMore && this.selectedMatchMore.radarId) {
        var url = config.radarUrl() + this.selectedMatchMore.radarId + "&u=" + this.$store.getters.accountId + "&t=" + this.$store.getters.sessionToken;
        var html = '<iframe src="' + url + '" frameborder="0" allowfullscreen="true" scrolling="no">';
        this.setWidget(html);
      }
    }
  }
};
</script>

<style>
/* Fix for single item in tab-nav */
.all-market .tab-nav ul li:only-child a {
  border-radius: 10px !important;
}

/* Live TV widget positioning */
.all-market #collapse-livetv {
  margin-top: 10px;
  width: 100%;
  overflow: hidden;
}

.all-market #collapse-livetv .live-tv-aspect {
  position: relative;
  width: 100%;
  aspect-ratio: 414 / 234;
}

.all-market #collapse-livetv .live-tv-aspect img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: none;
  margin: 0;
  object-fit: cover;
  display: block;
  border-radius: 0;
}

.all-market #collapse-livetv .highlight-match-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
}

.all-market #collapse-livetv .highlight-match-info i.fa-spinner {
  color: #fff;
  font-size: 24px;
}

.all-market #collapse-livetv .highlight-match-info span {
  color: #fff;
  padding: 10px;
}

.all-market #collapse-livetv #live-widget-iframe {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100% !important;
  height: 100% !important;
  border: 0;
  padding: 0;
  margin: 0;
  z-index: 1;
}

.all-market #collapse-livetv #live-widget-iframe iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  max-width: none;
  border: 0;
  display: block;
  padding: 0;
  margin: 0;
}

.all-market #collapse-livetv #live-widget-iframe > * {
  width: 100% !important;
  height: 100% !important;
  max-width: none;
}
</style>